import { storage } from '../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

// Sanitize file name to remove spaces and special characters
function sanitizeFileName(name) {
  return name.replace(/[^a-zA-Z0-9._-]/g, '_');
}

// Upload image to Firebase Storage
export async function uploadImage(file, path) {
  try {
    // Create a unique, sanitized filename
    const timestamp = Date.now();
    const originalName = file.name || 'image';
    const fileName = `${timestamp}_${sanitizeFileName(originalName)}`;
    const fullPath = `${path}/${fileName}`;
    
    // Create storage reference
    const storageRef = ref(storage, fullPath);
    
    // Upload file
    const snapshot = await uploadBytes(storageRef, file);
    
    // Get download URL
    const downloadURL = await getDownloadURL(snapshot.ref);
    
    return {
      url: downloadURL,
      path: fullPath,
      fileName: fileName
    };
  } catch (error) {
    console.error('Error uploading image:', error, {
      file,
      path,
      fileName: file && file.name
    });
    throw new Error('Failed to upload image. Please try again.');
  }
}

// Upload shop cover photo
export async function uploadShopCoverPhoto(file, userId) {
  return uploadImage(file, `shops/${userId}/cover-photos`);
}

// Upload product image
export async function uploadProductImage(file, sellerId, productId) {
  return uploadImage(file, `products/${sellerId}/${productId}`);
}

// Upload product video
export async function uploadProductVideo(file, sellerId, productId) {
  return uploadImage(file, `products/${sellerId}/${productId}/videos`);
}

// Upload product cover photo
export async function uploadProductCoverPhoto(file, sellerId, productId) {
  return uploadImage(file, `products/${sellerId}/${productId}/cover-photos`);
}

// Upload profile image
export async function uploadProfileImage(file, userId) {
  return uploadImage(file, `profiles/${userId}`);
}

// Validate image file
export function validateImageFile(file) {
  const maxSize = 5 * 1024 * 1024; // 5MB
  const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  
  if (!file) {
    throw new Error('No file selected');
  }
  
  if (file.size > maxSize) {
    throw new Error('Image must be under 5MB');
  }
  
  if (!allowedTypes.includes(file.type)) {
    throw new Error('Only JPG, PNG, GIF, and WebP images are allowed');
  }
  
  return true;
} 